import COMMON_CONSTANTS from "../constants/commonConstants";

const isServerUrlConfigured = process.env.REACT_APP_IS_SERVER_URL_CONFIGURED === "true" || false;

// In-memory cache by id so duplicate mounts (e.g. header + footer roots) trigger a single network call
const postDataCache = new Map();

export const getWordpressPostData = async (id, dataUrl) => {
    const cacheKey = `${id}:${dataUrl ?? ""}`;
    if (postDataCache.has(cacheKey)) {
        return postDataCache.get(cacheKey);
    }

    const promise = (async () => {
        try {
            const wordpressUrl = COMMON_CONSTANTS.getWordpressBaseUrl();
            const serverUrl = process.env.REACT_APP_SERVER_URL || "";
            const url = !isServerUrlConfigured ? `${wordpressUrl}${dataUrl}` : `${serverUrl}${COMMON_CONSTANTS.GET_WORDPRESS_DATA_ENDPOINT}?id=${id}&url=${dataUrl}&cache_bust=${new Date().getTime()}`;
            const response = await fetch(url);
            const data = await formatResponse(id, await response.json());
            return data;
        } catch (error) {
            console.error(`Error fetching menu from WordPress or Node.JS App Server: `, error);
            postDataCache.delete(cacheKey);
        }
    })();

    postDataCache.set(cacheKey, promise);
    return promise;
};


// Function to fetch card data
const fetchCardData = async (cardIds) => {
    try {
        const cardData = await Promise.all(
            cardIds.map(async (cardId) => {
                return await getWordpressPostData(`post${cardId}`, `/wp-json/wp/v2/posts/${cardId}`);
            })
        );
        return cardData;
    } catch (error) {
        console.error("Error fetching card data: ", error);
    }
};

const formatResponse = async (id, response) => {
    if (id === 'ampFeaturedCards') {
        const first = Array.isArray(response) && response.length > 0 ? response[0] : null;
        if (!first) {
            return {
                divider_type: null,
                divider_image: { url: null },
                divider_color: null,
                section_title: null,
                cards: [],
            };
        }
        const featuredSection = {
            divider_type: first?.acf?.divider_type,
            divider_image: {
                url: first?.acf?.divider_image?.url || null,
            },
            divider_color: first?.acf?.divider_color,
            section_title: first?.acf?.section_title,
        };
        if (first?.acf?.posts?.length) {
            if (isServerUrlConfigured) {
                featuredSection.cards = first.acf.posts.slice(-3);
            } else {
                const lastThreePosts = first.acf.posts.slice(-3);
                featuredSection.cards = await fetchCardData(lastThreePosts.map(post => post.ID));
            }
        } else {
            featuredSection.cards = [];
        }
        return featuredSection;
    }
    return response;
};
